import { GOOGLE_WEB_CLIENT_ID, GOOGLE_IOS_CLIENT_ID } from '../config/env';

const APP_NAME = 'Weight Loss Buddy';
const APP_VERSION = '1.0.0';

// API
const API_TIMEOUT = 30000; // 30s

// Pagination
const PAGE_SIZE = 20;

const GOOGLE_SIGN_IN_CONFIG = {
  webClientId: GOOGLE_WEB_CLIENT_ID,
  iosClientId: GOOGLE_IOS_CLIENT_ID,
  offlineAccess: true,
  forceCodeForRefreshToken: true,
};

export { APP_NAME, APP_VERSION, API_TIMEOUT, PAGE_SIZE, GOOGLE_SIGN_IN_CONFIG };
